var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"side-tab-panel side-panel-content"},[_c('div',{staticClass:"side-panel-content-wrap"},[_c('breadcrumbs'),_c('templateoptions'),_c('moduleoptions')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }